/* eslint-disable */

import React, { Component } from 'react';
import cIf from 'classnames';

import { VenuePlanKit, TicketsList, PriceRow } from '../selectprices';

var _ = require('lodash');
var tr = require('ts-translate-js').default.boundTR;

import {up, getMomentTZDateTime} from 'ts-util';
import { EventDatePriceListModel } from '../../../mvcapi/models/buyticket';
import { SiteCustomizationContext } from '../../../logic/reactcontext/site-customization-context';
import { AutoFindTicketModel } from '../../../logic/models';


/*
var PackageKitShape = PropTypes.shape({
    packageID: PropTypes.number,
    eventDateIDs: PropTypes.array
});
*/

export type EventDatePriceListProps = {
    packageKit: { packageID: number, eventDateIDs: number[], showOnlyWholePricesOnInternet: boolean },
    hideTicketQtyDistribution?: boolean,
    eventDate: EventDatePriceListModel,
    eventDatePriceRequest: any,
    creditCardMessageState: any,
    eventDateResult: any,
    selected: boolean,
    isTicketQtyDistributionReadonly: boolean,
    onChange: (eventDateID: number, priceRequest: any) => void,
    hasCreditCardMessageSeen: (creditCardConditionID: number) => void,
    onEventDateSelected: (eventDateID: number) => void,
    afterSearchTickets: () => void,
    resetPriceGroupQtyAfterClickToPriceName: (priceName: string) => void,
    onMoreInformationsClick: (membershipTypeId: string) => void,
    processing: boolean,
    onContentChange: () => void,
    onFindTicketsWhenNoPrice: (autoFindTicket: AutoFindTicketModel) => void,
    integ: string,
}

export class EventDatePriceList extends Component<EventDatePriceListProps> {
    static displayName: string;
    static defaultProps: { eventDatePriceRequest: {}; onEventDateSelected: boolean; isTicketQtyDistributionReadonly: boolean; };
    static contextType = SiteCustomizationContext;


    constructor(props) {
        super(props);
        
        
        this.handleChangeQty = this.handleChangeQty.bind(this);
        this.handleCreditCardMessageSeen = this.handleCreditCardMessageSeen.bind(this);
        this.handleOnEventDateSelected = this.handleOnEventDateSelected.bind(this);
    }

    handleChangeQty(priceID, price) {
        this.props.onChange(this.props.eventDate.EventDateID, up(this.props.eventDatePriceRequest, { [priceID]: { $set: price }}));
    }

    handleCreditCardMessageSeen(creditCardConditionID) {
        this.props.hasCreditCardMessageSeen(creditCardConditionID);
    }

    handleOnEventDateSelected() {
        this.props.onEventDateSelected(this.props.eventDate.EventDateID);
    }

    // autoFindTicket : object contains ticketQty and sectionid
    handleFindTicketsWhenNoPrice(autoFindTicket: AutoFindTicketModel) {
        if(this.props.onFindTicketsWhenNoPrice !== null) 
            this.props.onFindTicketsWhenNoPrice(autoFindTicket);
    }
    
    render() {
        const {siteSettings} = this.context;
        var pricesList = null;
        var content = null;
        var isInMultiEventMode = this.props.packageKit.packageID != null;
        var showOnlyWholePricesOnInternet = isInMultiEventMode && this.props.packageKit.showOnlyWholePricesOnInternet;

        // Build the price list
        if(this.props.eventDate.PriceGroups.length > 0) {
            if(!this.props.hideTicketQtyDistribution) {
                const priceRows = _.map(
                    this.props.eventDate.PriceGroups,
                    (priceitem) => <PriceRow key={priceitem.PriceID}
                                            isTicketQtyReadonly={this.props.isTicketQtyDistributionReadonly}
                                            priceitem={priceitem}
                                            showOnlyWholePricesOnInternet={showOnlyWholePricesOnInternet}
                                            numberoftickets={this.props.eventDate.Tickets.length}
                                            priceRequest={this.props.eventDatePriceRequest[priceitem.PriceID]}
                                            onChange={this.handleChangeQty}
                                            hasCreditCardMessageSeen={this.handleCreditCardMessageSeen}
                                            creditCardMessageState={this.props.creditCardMessageState}
                                            resetPriceGroupQtyAfterClickToPriceName={this.props.resetPriceGroupQtyAfterClickToPriceName}
                                            onMoreInformationsClick={this.props.onMoreInformationsClick}
                                            taxesOnlyAtCheckout={siteSettings.taxesOnlyAtCheckout}
                    />);
                
                pricesList = <div>
                    <div className="header">
                        <div className="row hidden-xs">
                            <h5 className="col-sm-4">{tsapp.tr("ticketpriceselection.rates")}</h5>
                            {(!showOnlyWholePricesOnInternet ?
                              <h5 className="col-sm-2 text-right">{tsapp.tr("ticketpriceselection.prices")}</h5>
                            : null)}
                            <h5 className={cIf("text-center", { "col-sm-offset-4": showOnlyWholePricesOnInternet, "col-sm-4":true })}>{tsapp.tr("ticketpriceselection.quantities")}</h5>
                            {(!showOnlyWholePricesOnInternet ?
                              <h5 className="col-sm-2 text-right">{tsapp.tr("ticketpriceselection.totals")}</h5>
                            : null)}
                        </div>

                        <div className="row  visible-xs-block">
                            <h5 className="col-xs-12">{tsapp.tr("ticketpriceselection.hereareyourprices")}</h5>
                        </div>
                    </div>

                    {priceRows}
                </div>;
            }
        } else {
            const autoFindTicket: AutoFindTicketModel = { sectionid: this.props.eventDate.SectionID, qty: this.props.eventDate.Tickets.length };

            let autoFindTicketButton = null;
            // On ne gère pas toute suite le multi event car trop compliqué de rechercher des nouveaux sièges dans les forfaits (modif trop longue)
            if(!isInMultiEventMode)
                autoFindTicketButton = <button className="btn btn-primary" onClick={() => this.handleFindTicketsWhenNoPrice(autoFindTicket)}>{tr("Chercher dans une autre section")}</button>;

            pricesList = (
                <div>
                    <div className="alert alert-danger"><ul className="list-inline"><li><strong>{tsapp.tr("ticketpriceselection.nopricesavailable")}</strong></li><li>{autoFindTicketButton}</li></ul></div>
                </div>
            );
        }
        
        // In multi-event mode, we show event header and ticket list
        if(isInMultiEventMode) {
            //console.log("multi event mode");
            var dateString = getMomentTZDateTime(this.props.eventDate.EventDate, this.props.eventDate.TZDatabaseID).format(tsapp.tr("program.format.moment.datetime"));
            var showErrorMessage = (this.props.eventDateResult != null && this.props.eventDateResult.ErrorMessage != "");


            var planCtl = this.props.selected && this.props.eventDate.VenuePlanInfo.planAvailable
                        ? <VenuePlanKit packageKit={this.props.packageKit}
                                        selectedEventDate={this.props.eventDate}
                                        afterSearchTickets={this.props.afterSearchTickets}
                                        processing={this.props.processing}>
                        </VenuePlanKit>
                        : null;

            content = (
                <div>
                    <div className={cIf("panel panel-default", { "panel-light": !this.props.selected,
                                                                 "panel-primary": this.props.selected })}>
                        <div className="panel-heading" onClick={this.handleOnEventDateSelected} style={{ cursor:'pointer' }}>
                            <div className="row">
                                <div className="col-xs-12 col-sm-8">
                                    <h4 className="panel-title">{this.props.eventDate.EventDateName}</h4>
                                </div>
                                <div className="col-sm-4 hidden-xs">
                                    <h4 className="panel-title text-right pull-right">{dateString}</h4>
                                </div>
                                <div className="col-xs-12 visible-xs">
                                    <h4 className="panel-title"><small>{dateString}</small></h4>
                                </div>
                            </div>
                        </div>
                        <div className="panel-body">

                            {// this.props.eventDate.Tickets peut être null dans le cas qu'il n'y a pas de prix pour l'event
                            (this.props.eventDate.ProductType == "Ticket" && this.props.eventDate.Tickets != null)
                            ? <TicketsList tickets={this.props.eventDate.Tickets}
                                           eventDateID={this.props.eventDate.EventDateID}
                                           showPlan={isInMultiEventMode && this.props.eventDate.VenuePlanInfo.planAvailable}
                                           onShowPlanClick={this.handleOnEventDateSelected}
                                           onContentChange={this.props.onContentChange} 
                                />
                            : null}

                            <div className="row">
                                {planCtl}
                                {isInMultiEventMode
                                    ? <div className={cIf({ "col-xs-12": planCtl == null, "col-lg-12 col-sm-12": planCtl != null })}>
                                        {pricesList}
                                    </div> 
                                    : <div className={cIf({ "col-xs-12": planCtl == null, "col-lg-8 col-sm-12": planCtl != null })}>
                                        {pricesList}
                                    </div>
                                }
                                {showErrorMessage ? <div className="alert alert-danger"><strong>{this.props.eventDateResult.ErrorMessage}</strong></div> : null}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        else
            content = pricesList;



        return (
            <div>
                {content}
            </div>
        );
    }
};

// EventDatePriceList.propTypes = {
//     packageKit: PackageKitShape,
//     isTicketQtyDistributionReadonly: PropTypes.bool, // In a package, we keep only the first event editable. The other are readonly because they follow the first event.
//     hideTicketQtyDistribution: PropTypes.bool, // In a package, we keep only the first event editable. The other are readonly because they follow the first event.
//     eventDate: PropTypes.object.isRequired,
//     eventDatePriceRequest: PropTypes.object.isRequired,
//     creditCardMessageState: PropTypes.object,
//     eventDateResult: PropTypes.object,
//     selected: PropTypes.bool, // Tells if the venue plan must be opened (When we display a lot of event dates like in the packages)
//     onChange: PropTypes.func,
//     hasCreditCardMessageSeen: PropTypes.func,
//     onEventDateSelected: PropTypes.func, // When this control is shown multiple times (package mode) we can select them in order to view the venue plan of this specific event date...
//     afterSearchTickets: PropTypes.func,
//     resetPriceGroupQtyAfterClickToPriceName: PropTypes.func,
//     onMoreInformationsClick: PropTypes.func,
//     processing: PropTypes.bool,
//     onContentChange: PropTypes.func,
//     onFindTicketsWhenNoPrice: PropTypes.func
// }
